import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import styled from 'styled-components';

import { setGroupList } from '../../actions/set-Group';
import { setPlaylist } from '../../actions/set-Playlist';

import { resetMemory } from '../../other/last-opened-mode';

import {
  Route,
  Switch,
  useHistory,
  useLocation,
  useParams,
} from 'react-router-dom';
import { loadGroup, loadPlaylist } from '../../other/load-playlist';

import PlayerSeries from '../Series/PlayerSeries';
import BackgroundPlayer from './BackgroundPlayer';
import GroupRow from './GroupRow';
import MoreInfo from './MoreInfo';

import PlayerVod from './PlayerVod';
import RowItem from './RowItem';

import {
  VariableSizeGrid as Grid,
  VariableSizeList as List,
} from 'react-window';
import { useLang } from '../../language/LanguageProvider.jsx';
import { convertRemToPixels, convertVhToPixels } from '../../other/convert-rem';
import { media } from '../../other/breakpoints';
import Popup from '../Popup/Popup';

import DB from '../../other/local-db';
import {
  SORT_ORDERS,
  getDefaultVodSort,
  setVodSort,
  sortVodItems,
} from '../../other/sort-vod';

import { Loading } from '../../other/Player-github/style';

const Container = styled.div`
  height: 100vh;
  overflow: auto;
  max-width: 100%;
  overflow-x: hidden;
  transition: filter 0.5s ease;
  background-color: var(--first-color);

  ${media.mobile} {
    height: auto;
    min-height: 100vh;
    overflow: visible;
    overflow-x: hidden;
  }
`;

const Spin = styled.div`
  height: 100vh;
  overflow: auto;
  overflow-y: auto;
  max-width: 100%;
  width: 100vw;
  overflow-x: hidden;
  background-color: transparent;
  position: absolute;
  z-index: 100000000000000000;

  display: flex;
  justify-content: center;
  align-items: center;
`;

const GroupRowContainer = styled.ul`
  padding-top: 2rem;
  padding-bottom: 2rem;
  background-color: var(--first-color);
  list-style-type: none;
  padding-left: 1.7rem;
  max-width: 100vw;
  overflow: hidden;
  z-index: 1;

  ${media.mobile} {
    overflow: visible;
  }
`;

const SortBar = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 0.75rem;
  padding: 1.25rem 2rem 0.5rem 2rem;
  margin-bottom: 0.75rem;
  width: 100%;
`;

const SortSelect = styled.select`
  background: #1b1f24;
  color: #fff;
  border: 1px solid #4d4d4d;
  border-radius: 4px;
  padding: 0.45rem 0.65rem;
  min-width: 220px;
  outline: 0;
  font-weight: 600;
  &:focus {
    border-color: var(--second-color);
    box-shadow: 0 0 0 0.2rem var(--second-color-shadow);
    transition: all 0.5s ease;
  }
`;

const MainVod = () => {
  const { t } = useLang();
  const { category, playingMode } = useParams();

  const [streamList, setStreamList] = useState([]); //downloaded provider
  const [playlist, setPlaylistState] = useState(streamList); //used on player

  const [allItems, setAllItems] = useState(true);
  const [loadedCategory, setLoadedCategory] = useState(-1);
  const [showPopup, setShowPopup] = useState(false);

  const categories = useSelector((state) => state.groupsList);

  const [randomMovie, setRandomMovie] = useState();

  const [blurBackground, setBlurBackground] = useState();
  const [isLoading, setIsLoading] = useState(true);

  const [sortOrder, setSortOrder] = useState(getDefaultVodSort());

  const dispatch = useDispatch();
  const history = useHistory();
  const location = useLocation();

  const query = useQuery();
  const searchText = query.get('search');

  const [refresh, setRefresh] = useState(1);

  useEffect(() => {
    const handleResize = () => {
      setRefresh((prev) => prev + 1);
    };

    const handleOrientationChange = () => {
      setTimeout(() => {
        setRefresh((prev) => prev + 1);
      }, 100);
    };

    window.addEventListener('resize', handleResize);
    window.addEventListener('orientationchange', handleOrientationChange);

    return () => {
      window.removeEventListener('resize', handleResize);
      window.removeEventListener('orientationchange', handleOrientationChange);
    };
  }, []);

  useEffect(() => {
    if (location.pathname.match(/category/) && !category) showBlur(1);
    else
      location.pathname.match(/info|fullscreen|menu/)
        ? showBlur(1)
        : showBlur(0);
  }, [location.pathname, category]);

  useEffect(() => {
    if (location.pathname.match(/category/) && !category) showBlur(1);
    else
      location.pathname.match(/info|fullscreen|menu/)
        ? showBlur(1)
        : showBlur(0);
    setAllItems(
      (isNaN(category) && category === undefined) ||
        location.pathname.match(/info|fullscreen|menu/)
    );
    if (!location.pathname.match(/info|fullscreen|menu/))
      setRandomMovie({
        ...searchRandomMovie(
          isNaN(category) && category === undefined
            ? playlist
            : playlist.filter((x) => x.category_id === category)
        ),
      });
  }, [category]);

  useEffect(() => {
    if (!searchText) {
      const shouldSort = !category || !isNaN(category);
      const next = shouldSort
        ? sortVodItems(streamList, sortOrder, playingMode === 'series')
        : streamList;
      setPlaylistState(next);
      setShowPopup(0);
      return;
    }
    const searchedRaw = searchText
      ? streamList.filter((x) =>
          x.name.toLowerCase().includes(searchText.toLowerCase())
        )
      : streamList;
    const shouldSort = !category || !isNaN(category);
    const searched = shouldSort
      ? sortVodItems(searchedRaw, sortOrder, playingMode === 'series')
      : searchedRaw;
    if (searched.length === 0) {
      const base = shouldSort
        ? sortVodItems(streamList, sortOrder, playingMode === 'series')
        : streamList;
      setPlaylistState(base);
      setShowPopup(1);
    } else setPlaylistState(searched);
  }, [searchText, sortOrder]);

  useEffect(() => {
    const f = async () => {
      let cat = categories;
      const reset = resetMemory(playingMode);
      if (
        reset === false &&
        (location.pathname.match(/info|fullscreen|menu/) ||
          (location.pathname.match(/category/) && category === undefined) ||
          category === loadedCategory)
      ) {
        return;
      }

      setLoadedCategory(category);
      setAllItems(
        (isNaN(category) && category === undefined) ||
          location.pathname.match(/info|fullscreen|menu/)
      );

      showBlur(1);
      setIsLoading(true);

      setRefresh(0);
      if (reset === true || cat.length === 0) {
        await loadGroup(playingMode).then((gps) => {
          if (!gps || gps.length === 0) {
            history.replace('/');
            return;
          }
          gps.unshift(
            {
              category_id: 'fav',
              favorite: 1,
              category_name: t('main.favorites'),
            },
            {
              category_id: 'toend',
              history: 1,
              category_name: t('main.continueWatching'),
            }
          );
          dispatch(setGroupList(gps || []));
          cat = gps;
        });
      }
      await loadPlaylist(playingMode, category || 'ALL').then((chs) => {
        if (category && isNaN(category)) {
          chs = chs.filter((s) => {
            const f = DB.findOne(
              playingMode,
              playingMode === 'series' ? s.series_id : s.stream_id,
              category === 'fav'
            );
            return f && (category === 'fav' || (f.tot > 3 && f.tot < 95));
          });
        }
        const shouldSort = !category || !isNaN(category);
        const sorted = shouldSort
          ? sortVodItems(chs || [], sortOrder, playingMode === 'series')
          : chs || [];
        dispatch(setPlaylist(sorted));
        showBlur(0);
        setStreamList(chs || []);
        setPlaylistState(sorted);
        setRandomMovie({
          ...searchRandomMovie(
            isNaN(category) && category === undefined
              ? sorted
              : sorted.filter((x) => x.category_id === category)
          ),
        });
        setRefresh(1);
      });
    };
    f().catch((err) => console.log(err));
  }, [dispatch, category, playingMode, location.pathname]);

  const showBlur = (mode) => {
    setBlurBackground(
      mode !== 0 ? { filter: 'blur(.5rem)', pointerEvents: 'none' } : {}
    );
    if (mode === 0) setIsLoading(false);
  };

  const Row = ({ index, style }) => {
    if (index === 0) {
      const isMobile = window.innerWidth <= 900;
      const navbarHeight = isMobile ? '4.5rem' : '4rem';
      return randomMovie && randomMovie.name ? (
        <div style={{ ...style, paddingTop: navbarHeight, paddingBottom: '4rem' }}>
          <BackgroundPlayer
            key={`bg-${randomMovie.stream_id || randomMovie.series_id}`}
            name={randomMovie.name}
            category_id={randomMovie.category_id}
            stream_id={randomMovie.stream_id || randomMovie.series_id}
            isSeries={playingMode === 'series'}
            stream_icon={randomMovie.stream_icon || randomMovie.cover}
            existingTmdb={randomMovie.tmdb}
            title={
              category &&
              (isNaN(category)
                ? t('main.continueWatching')
                : categories.find(
                    (x) => parseInt(x.category_id) === parseInt(category)
                  ).category_name)
            }
          />
        </div>
      ) : (
        <div style={{ paddingTop: navbarHeight }}></div>
      );
    }

    if (index === 1) {
      return (
        <div style={style}>
          <SortBar>
            <div
              style={{ display: 'flex', alignItems: 'center', gap: '0.75rem' }}>
              <span style={{ color: 'white', fontWeight: 600 }}>
                {t('sort.title')}:{' '}
              </span>
              <SortSelect
                value={sortOrder}
                onChange={(e) => {
                  const v = e.target.value;
                  setSortOrder(v);
                  setVodSort(v);
                  const shouldSort = !category || !isNaN(category);
                  const base = shouldSort
                    ? sortVodItems(streamList, v, playingMode === 'series')
                    : streamList;
                  setPlaylistState(base);
                }}>
                <option value={SORT_ORDERS.ID_DESC}>
                  {t('sort.lastAddedDesc')}
                </option>
                <option value={SORT_ORDERS.ID_ASC}>
                  {t('sort.lastAddedAsc')}
                </option>
                <option value={SORT_ORDERS.AZ}>{t('sort.az')}</option>
                <option value={SORT_ORDERS.ZA}>{t('sort.za')}</option>
              </SortSelect>
            </div>
            {category && category !== undefined && (
              <button
                onClick={() => history.replace(`/${playingMode}/`)}
                style={{
                  background: 'transparent',
                  border: 'none',
                  color: 'var(--second-color)',
                  cursor: 'pointer',
                  fontSize: '1rem',
                  fontWeight: 600,
                  display: 'flex',
                  alignItems: 'center',
                  gap: '0.5rem',
                }}>
                <i className="fas fa-arrow-left"></i>
                {playingMode === 'live' && t('lateral.live')}
                {playingMode === 'movie' && t('lateral.movies')}
                {playingMode === 'series' && t('lateral.series')}
              </button>
            )}
          </SortBar>
        </div>
      );
    }

    return (
      <GroupRow
        key={categories[index - 2].category_id}
        category_id={categories[index - 2].category_id}
        name={categories[index - 2].category_name}
        isSeries={playingMode === 'series'}
        playlist={getGroupRowPlaylist(index)}
        style={{ ...style, paddingLeft: '1.8rem', textDecoration: 'none' }}
      />
    );
  };

  const Cell = ({ columnIndex, rowIndex, style }) => {
    if (rowIndex === 0) {
      if (columnIndex !== 0) return null;
      else {
        const isMobile = window.innerWidth <= 900;
        const navbarHeight = isMobile ? '4.5rem' : '4rem';
        return randomMovie && randomMovie.name ? (
          <div style={{ ...style, paddingTop: navbarHeight }}>
            <BackgroundPlayer
              key={`bg-${randomMovie.stream_id || randomMovie.series_id}`}
              name={randomMovie.name}
              category_id={randomMovie.category_id}
              stream_id={randomMovie.stream_id || randomMovie.series_id}
              isSeries={playingMode === 'series'}
              stream_icon={randomMovie.stream_icon || randomMovie.cover}
              existingTmdb={randomMovie.tmdb}
              title={
                category &&
                (isNaN(category)
                  ? getOtherCategoryName(category)
                  : categories.find(
                      (x) => parseInt(x.category_id) === parseInt(category)
                    ).category_name)
              }
            />
          </div>
        ) : (
          <div style={{ paddingTop: navbarHeight }}>
            <h3 style={{ color: 'white', marginLeft: '1%' }}>
              {category &&
                categories.length > 0 &&
                (isNaN(category)
                  ? getOtherCategoryName(category)
                  : categories.find(
                      (x) => parseInt(x.category_id) === parseInt(category)
                    ).category_name)}
            </h3>
          </div>
        );
      }
    } else {
      const index = (rowIndex - 1) * 6 + columnIndex;
      if (!playlist[index]) return null;
      return (
        <RowItem
          id={index}
          key={'vod' + (playlist[index].stream_id || playlist[index].series_id)}
          name={playlist[index].name}
          stream_icon={playlist[index].stream_icon || playlist[index].cover}
          stream_id={playlist[index].stream_id || playlist[index].series_id}
          stream_url={playlist[index].direct_source}
          isSeries={playingMode === 'series'}
          container_extension={playlist[index].container_extension}
          category_id={playlist[index].category_id}
          existingTmdb={playlist[index].tmdb}
          last={false}
          style={{
            ...style,
            paddingBottom: '.7rem',
            marginLeft: '1%',
            textDecoration: 'none',
          }}
        />
      );
    }
  };

  const getGroupRowPlaylist = (index) => {
    const categoryIndex = index - 2;
    if (
      categories[categoryIndex].history === 1 ||
      categories[categoryIndex].favorite === 1
    ) {
      return streamList.filter((s) => {
        const f = DB.findOne(
          playingMode,
          playingMode === 'series' ? s.series_id : s.stream_id,
          categories[categoryIndex].favorite === 1
        );
        return (
          f &&
          (categories[categoryIndex].favorite === 1 ||
            (f.tot > 3 && f.tot < 95))
        );
      });
    } else {
      return playlist.filter(
        (s) =>
          parseInt(s.category_id) ===
          parseInt(categories[categoryIndex].category_id)
      );
    }
  };

  const getOtherCategoryName = (cat) =>
    cat === 'fav' ? t('main.favorites') : t('main.continueWatching');

  return (
    <div>
      <Route path="/:playingMode/">
        {isLoading === true && (
          <Spin>
            <Loading color={'var(--second-color);'}>
              <div>
                <div />
                <div />
                <div />
              </div>
            </Loading>
          </Spin>
        )}
        <Container style={{ ...blurBackground, overflowY: window.innerWidth <= 900 ? 'visible' : 'hidden' }}>
          <GroupRowContainer
            style={{ paddingLeft: '0rem', paddingTop: '1rem' }}>
            {refresh !== 0 &&
              (allItems && playlist.length > 0 ? (
                <List
                  refresh={refresh}
                  height={convertVhToPixels('100vh') - convertRemToPixels(3.5)}
                  itemCount={categories.length + 2}
                  itemSize={(index) => {
                    if (index === 0) {
                      const isMobile = window.innerWidth <= 900;
                      const navbarHeight = isMobile ? convertRemToPixels(4.5) : convertRemToPixels(4);
                      return convertVhToPixels('70vh') + convertRemToPixels(1) + navbarHeight;
                    } else if (index === 1) {
                      return convertRemToPixels(5);
                    } else if (getGroupRowPlaylist(index).length > 0) {
                      const isMobile = window.innerWidth <= 900;
                      const baseHeight = isMobile
                        ? convertVhToPixels('40vw') * 1.5 + convertRemToPixels(1.75 + 1.5)
                        : convertVhToPixels('15vw') * 1.8 + convertRemToPixels(1.75);
                      const marginTop = index > 1 ? (isMobile ? convertRemToPixels(2.5) : convertRemToPixels(2)) : 0;
                      return baseHeight + marginTop;
                    } else {
                      return 0;
                    }
                  }}
                  useIsScrolling={true}
                  style={{ overflowX: 'hidden' }}>
                  {Row}
                </List>
              ) : (
                <Grid
                  columnCount={6}
                  columnWidth={(index) =>
                    index === 0
                      ? convertVhToPixels('16.6vw')
                      : convertVhToPixels('16.6vw')
                  }
                  height={convertVhToPixels('100vh') - convertRemToPixels(3.5)}
                  rowCount={parseInt(Math.ceil(playlist.length / 6)) + 1}
                  rowHeight={(index) => {
                    if (index === 0) {
                      const isMobile = window.innerWidth <= 900;
                      const navbarHeight = isMobile ? convertRemToPixels(4.5) : convertRemToPixels(4);
                      if (randomMovie && randomMovie.name)
                        return convertVhToPixels('70vh') + navbarHeight;
                      else return convertVhToPixels('5vh') + navbarHeight;
                    } else return convertVhToPixels('15vw') * 1.5;
                  }}
                  width={convertVhToPixels('100vw')}
                  useIsScrolling={true}
                  style={{ overflowX: 'hidden' }}>
                  {Cell}
                </Grid>
              ))}
          </GroupRowContainer>
        </Container>
        {showPopup && (
          <Popup
            title={t('main.noStreamTitle', { text: searchText })}
            description={t('main.noStreamDescription')}
            icon={'fas fa-search'}
            onclick={() => {
              setShowPopup(0);
              history.replace(location.pathname.split('?')[0]);
            }}
          />
        )}
        <Switch>
          <Route path="/movie/category/:category/:stream_id/play/">
            <PlayerVod />
          </Route>
          <Route path="/series/category/:category/:stream_id/play/season/:season/episode/:episode/">
            <PlayerSeries />
          </Route>
          <Route path="/:playingMode/category/:category/:stream_id/info/">
            <MoreInfo key={'info-' + category} />
          </Route>
        </Switch>
      </Route>
    </div>
  );
};

export default MainVod;

function searchRandomMovie(playlist) {
  playlist = playlist.filter(
    (x) =>
      !x.name.match(
        /xxx|porn|sex|bbc|bitch|cunt|cock|cum|piss|anal|tits|blowjob|masturbate|dick|suck|gangbang/i
      )
  );
  const tempPlaylist = playlist.filter((x) => x.rating >= 7);
  if (tempPlaylist.length > 0) {
    return { ...tempPlaylist[Math.floor(Math.random() * tempPlaylist.length)] };
  } else return { ...playlist[Math.floor(Math.random() * playlist.length)] };
}

const useQuery = () => {
  return new URLSearchParams(useLocation().search);
};
